<template>
    <CollectionsCarouselList v-if="collectionLoaded" :collections="allCollections"/>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import CollectionsCarouselList from '@/components/CollectionsCarouselList.vue'
import Carousel from '@/components/Carousel.vue'

export default Vue.extend({
  name: 'collectionsCarouselHost',
  components: {
    CollectionsCarouselList
  },
  data() {
    return {
      allCollections: [],
      collectionLoaded: false
    }
  },
  computed: {
    ...mapGetters({
        collections: 'productCatalog/collections'
    }),
  },
  mounted () {
    if(this.collections.length === 0) {
      this.loadAllCollections().then(response => {
        this.allCollections = response.body.result.items
        this.collectionLoaded = true
      })
    } else {
      this.allCollections = this.collections
      this.collectionLoaded = true
    }
  },
  methods: {
    ...mapActions({
      loadAllCollections: 'productCatalog/loadAllCollections'
    })
  }
})
</script>
